<template>
    <div class="flex flex-col gap-10">
        <div >
            <p class="mb-4 flex items-center gap-2 text-base font-bold leading-6 text-black">
                {{$t('gpt.gptInnovation')}}

                <span class="th-tooltip th-tooltip-bottom-start cursor-pointer" :data-tip="$t('gpt.gptInnovationTip')">
                    <PtIcon icon="SolidInfo" class="fill-grey-55 text-2xl" />
                </span>

            </p>
            <div v-if="gptLoading" class="th-loading th-loading-spinner th-loading-md bg-grey-200"></div>

            <p v-else-if="gptSummary?.innovation_point?.length" class="px-8 py-5 text-sm leading-5 text-black odd:bg-grey-10 even:bg-grey-30" v-for="(item, index) in gptSummary?.innovation_point" :key="index">
                {{ `${index+1}.${item}` }}
            </p>

            <p v-else class="text-sm leading-5 text-black">
                {{ $t('gpt.noGPT')}}
            </p>
        </div>

        <div>
            <p class="mb-4 flex items-center gap-2 text-base font-bold leading-6 text-black">
                {{$t('gpt.gptAvoidance')}}

                <span class="th-tooltip th-tooltip-bottom-start cursor-pointer" :data-tip="$t('gpt.gptAvoidanceTip')">
                    <PtIcon icon="SolidInfo" class="fill-grey-55 text-2xl" />
                </span>

            </p>

            <div v-if="gptLoading" class="th-loading th-loading-spinner th-loading-md bg-grey-200"></div>

            <p v-else-if="gptSummary?.improvement_direction?.length" class="px-8 py-5 text-sm leading-5 text-black odd:bg-grey-10 even:bg-grey-30" v-for="(item, index) in gptSummary?.improvement_direction" :key="index">
                {{ `${index+1}.${item}` }}
            </p>

            <p v-else class="text-sm leading-5 text-black">
                {{ $t('gpt.noGPT')}}
            </p>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useDocumentCompareGPT } from '@/composables/use-document-compare-gpt';
import { useGlobalState } from '@/composables/use-global-store';
import { PtIcon } from 'patsnap-biz';
import '@patsnap-ui/icon/assets/solid/info.svg';

const props = defineProps<{
    patent_id: string
}>()

const { inputLang, transLang } = useGlobalState();
const { gptLoading, gptSummary } = useDocumentCompareGPT({
    patent_id: props.patent_id,
    inputLang: inputLang.value,
    transLang: transLang.value,
});

</script>
